import { render, staticRenderFns } from "./NotesDraw.vue?vue&type=template&id=19136a3d&scoped=true"
import script from "./NotesDraw.vue?vue&type=script&lang=js"
export * from "./NotesDraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19136a3d",
  null
  
)

export default component.exports